import { SVGProps } from 'react';

export type SVGRProps = {
  title?: string;
  titleId?: string;
};

const SvgInterfacechevronDown = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    aria-labelledby={titleId}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      clipRule="evenodd"
      d="M21.482 7.8 20.4 6.716l-8.3 8.301-8.3-8.2L2.716 7.9l9.384 9.384 9.381-9.485Z"
      fill={props.color}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgInterfacechevronDown;
